module.exports = __webpack_public_path__ + "static/media/Layout13.dfbe9069.png";